type CurrencyType = '₹' | '$' | '€'

export const currency: CurrencyType = '$'

export const currentYear = new Date().getFullYear()

export const credits = {
  name: 'Techzaa',
  buyLink: '',
}

export const basePath: string = '/'

export const constants = {
  BOTH: 'BOTH',
}
